import { styled } from "@mui/material/styles";
import SvgLogoWhite from "./Logos/White";

export default function SdxLogo() {
  return (
    <Wrapper>
      <SvgLogoWhite></SvgLogoWhite>
    </Wrapper>
  );
}

const Wrapper = styled("div")(() => ({
  width: 120,
}));
